package br.com.duoma.duomaproducao.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import br.com.duoma.duomaproducao.ui.misc.isCompactScreen
import br.com.duoma.duomaproducao.ui.misc.mediaQuery
import br.com.duoma.duomaproducao.ui.theme.ProducaoTheme
import kotlin.math.floor

@Preview
@Composable
fun FlowChartNodePreview() {
    ProducaoTheme {
        FlowChartNode("TAPEÇARIA", 10, 8.0)
    }
}

@Composable
fun FlowChartNode(
    title: String,
    today: Int?,
    weekAvg: Double,
    modifier: Modifier = Modifier,
    compact: Boolean = false,
    onClick: () -> Unit = {}
) {
    val useCompactLayout = compact || isCompactScreen()

    Card(
        onClick = onClick,
        modifier = modifier.width(mediaQuery(210.dp, 88.dp)),
        elevation = CardDefaults.elevatedCardElevation(defaultElevation = 3.dp, hoveredElevation = 8.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        shape = RoundedCornerShape(10.dp)
    ) {
        Column {
            Box(
                Modifier
                    .fillMaxWidth()
                    .height(6.dp)
                    .background(MaterialTheme.colorScheme.primary)
            )

            Column(
                Modifier.padding(
                    horizontal = if (useCompactLayout) 8.dp else 16.dp,
                    vertical = if (useCompactLayout) 8.dp else 12.dp
                )
            ) {
                Text(
                    text = title.uppercase(),
                    modifier = Modifier.fillMaxWidth(),
                    textAlign = TextAlign.Center,
                    style = if (useCompactLayout) MaterialTheme.typography.labelSmall else MaterialTheme.typography.labelLarge,
                    fontSize = mediaQuery(
                        MaterialTheme.typography.labelLarge.fontSize,
                        9.sp
                    ),
                    fontWeight = FontWeight.Bold,
                    letterSpacing = 0.sp,
                    color = MaterialTheme.colorScheme.primary
                )

                Spacer(Modifier.height(if (useCompactLayout) 6.dp else 10.dp))

                Box(
                    Modifier
                        .fillMaxWidth()
                        .height(1.dp)
                        .background(MaterialTheme.colorScheme.outlineVariant)
                )

                Spacer(Modifier.height(if (useCompactLayout) 8.dp else 12.dp))

                val avgValue = if (floor(weekAvg).toInt() == weekAvg.toInt()) weekAvg.toInt() else weekAvg
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = if (today != null) Arrangement.SpaceEvenly else Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (today != null) {
                        NodeStat(
                            label = "HOJE",
                            value = today.toString(),
                            modifier = Modifier.weight(1f),
                            compact = useCompactLayout
                        )
                        Box(
                            Modifier
                                .width(1.dp)
                                .height(if (useCompactLayout) 24.dp else 44.dp)
                                .background(MaterialTheme.colorScheme.outlineVariant)
                        )
                    }
                    NodeStat(
                        label = if (useCompactLayout) "MÉD." else "MÉD. DIA",
                        value = avgValue.toString().replace('.', ','),
                        modifier = Modifier.weight(1f),
                        compact = useCompactLayout
                    )
                }

                Spacer(Modifier.height(4.dp))
            }
        }
    }
}

@Composable
private fun NodeStat(
    label: String,
    value: String,
    modifier: Modifier = Modifier.width(80.dp),
    compact: Boolean = false
) {
    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = modifier) {
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            fontSize = mediaQuery(12.sp, 8.sp),
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            letterSpacing = 0.sp
        )
        Spacer(Modifier.height(2.dp))
        Text(
            text = value,
            style = if (compact) MaterialTheme.typography.titleLarge else MaterialTheme.typography.headlineSmall,
            fontSize = mediaQuery(26.sp, 16.sp),
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.secondary
        )
    }
}
